import { FETCH_AVAILABILITY_COMPLETED } from 'Rentlio/state/types'
import createReducer from 'Rentlio/state/utils/createReducer'

/**
 const initialState = [
 ...
 {
    id: int,
    name: string,
    paymentType: int, // Enum
    priceBeforeTax: float,
    priceAfterTax: float,
    taxes: object[]
   }
 ...
 ]
 */

const initialState = []

const touristTaxes = createReducer(initialState)({
  [FETCH_AVAILABILITY_COMPLETED]: (state, action) => [...action.payload.touristTaxes]
})

export default touristTaxes
